export default {
  name: 'colorHex',
  type: 'layout',
  active: false,
  data: {
    color: ''
  }
}
